import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsBackward20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSkip5SecondsBackward20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.899 3.799a.83.83 0 0 1 1.103 0 .68.68 0 0 1 0 1.016L11.715 6h2.997a3.25 3.25 0 0 1 3.25 3.25v4.5a3.25 3.25 0 0 1-3.25 3.25h-3.75a.75.75 0 0 1 0-1.5h3.75a1.75 1.75 0 0 0 1.75-1.75v-4.5a1.75 1.75 0 0 0-1.75-1.75h-2.997l1.287 1.185a.68.68 0 0 1 0 1.016.83.83 0 0 1-1.103 0L9.246 7.258a.68.68 0 0 1 0-1.016zM4.313 12.25c.675 0 1.122-.49 1.126-.984.005-.573-.395-.971-.813-.971-.506 0-.869.116-1.093.22a1.6 1.6 0 0 0-.283.165l-.002.002A.75.75 0 0 1 2 10.12V6.5h3.564a.75.75 0 1 1 0 1.5H3.5v.937a4.3 4.3 0 0 1 1.126-.143c1.458 0 2.323 1.3 2.313 2.484-.012 1.415-1.229 2.471-2.626 2.471a3.2 3.2 0 0 1-1.482-.374 3.3 3.3 0 0 1-.568-.381l-.012-.011-.005-.005-.002-.002h-.001l.507-.553-.508.552a.75.75 0 0 1 1.01-1.109l.007.005q.012.011.049.038a1.7 1.7 0 0 0 1.006.34"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsBackward20);
